import { Component, Input, Output, ContentChildren, ContentChild, ViewChild, ViewChildren, TemplateRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { QueryMode } from './query.types';
import { ValueInputTemplateDirective } from './directives/value-input-template.directive';
import { FieldDirective } from './directives/field.directive';
import { ToolbarTemplateDirective } from './directives/toolbar-template.directive';
import { translateTemplates, translateFields } from './utils/field-helper';
import { translateQueryGroup } from './utils/query-helper';
import { PlainComponent } from './plain/plain.component';
import { AdvancedComponent } from './advanced/advanced.component';
import { QueryConfigurationService } from './services/configuration.service';
var QueryComponent = (function () {
    function QueryComponent(config) {
        this.config = config;
        this.query = new EventEmitter();
        this.reset = new EventEmitter();
        this.datePickerReadonly = false;
        this.mode = QueryMode.plain;
        this.showModeButtons = true;
        this.plainMode = QueryMode.plain;
        this.advancedMode = QueryMode.advanced;
        this._queryTemplates = [];
    }
    Object.defineProperty(QueryComponent.prototype, "fieldTemplates", {
        get: function () {
            return this._fieldTemplates;
        },
        set: function (val) {
            this._fieldTemplates = val;
            if (val) {
                // only set this if results were brought back
                var arr = val.toArray();
                if (arr.length) {
                    // translate them to normal objects
                    this.fields = translateTemplates(arr);
                    if (this._queryTemplates) {
                        this.queryTemplates = this._queryTemplates;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryComponent.prototype, "fields", {
        get: function () {
            return this.tempFields;
        },
        set: function (val) {
            this.translateFields(val, this._valueInputTemplates);
            this.tempFields = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryComponent.prototype, "queryTemplates", {
        get: function () {
            return this._queryTemplates;
        },
        set: function (val) {
            var _this = this;
            this._queryTemplates = val;
            this._queryTemplates.forEach(function (queryTemplate) {
                _this.translateQueryGroup(queryTemplate.template, _this.tempFields);
            });
            if (this.tempFields && this.tempFields.length > 0) {
                this.queryTemplateChanged(this._queryTemplates[0]);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryComponent.prototype, "defaultValueInputTemplates", {
        set: function (val) {
            this._valueInputTemplates = val;
            this.translateFields(this.tempFields, this._valueInputTemplates);
        },
        enumerable: true,
        configurable: true
    });
    QueryComponent.prototype.getQuery = function () {
        var query;
        if (this.mode === QueryMode.plain) {
            query = this._plainQuery.getQuery();
        }
        else if (this.mode === QueryMode.advanced) {
            query = this._advancedQuery.getQuery();
        }
        else {
            throw new Error("Not implement the mode '" + this.mode + "'.");
        }
        return query;
    };
    QueryComponent.prototype.getOriginalQuery = function () {
        var query;
        if (this.mode === QueryMode.plain) {
            query = this._plainQuery.getOriginalQuery();
        }
        else if (this.mode === QueryMode.advanced) {
            query = this._advancedQuery.getOriginalQuery();
        }
        else {
            throw new Error("Not implement the mode '" + this.mode + "'.");
        }
        return query;
    };
    QueryComponent.prototype.validateQuery = function () {
        var result = true;
        if (this.mode === QueryMode.plain) {
            result = this._plainQuery.validateQuery();
        }
        else if (this.mode === QueryMode.advanced) {
            result = this._advancedQuery.validateQuery();
        }
        else {
            throw new Error("Not implement the mode '" + this.mode + "'.");
        }
        return result;
    };
    QueryComponent.prototype.showPlainPanel = function () {
        this.mode = QueryMode.plain;
    };
    QueryComponent.prototype.showAdvancedPanel = function () {
        this.mode = QueryMode.advanced;
    };
    QueryComponent.prototype.queryTemplateChanged = function (queryTemplate) {
        this.currentQueryTemplate = queryTemplate;
    };
    QueryComponent.prototype.resetQueryTemplate = function () {
        var args = {
            queryTemplate: this.currentQueryTemplate
        };
        this.reset.emit(args);
        if (this.mode === QueryMode.plain) {
            this._plainQuery.reset();
        }
        if (this.mode === QueryMode.advanced) {
            this._advancedQuery.reset();
        }
    };
    QueryComponent.prototype.executeQuery = function () {
        if (this.validateQuery()) {
            var query = this.getQuery();
            this.query.emit(query);
        }
    };
    QueryComponent.prototype.translateFields = function (fields, valueInputTemplates) {
        if (fields && fields.length > 0 && valueInputTemplates && valueInputTemplates.length > 0) {
            translateFields(fields, valueInputTemplates);
        }
    };
    QueryComponent.prototype.translateQueryGroup = function (queryGroup, fields) {
        if (fields && fields !== null && fields.length > 0 && queryGroup !== null) {
            translateQueryGroup(queryGroup, fields);
        }
    };
    return QueryComponent;
}());
export { QueryComponent };
QueryComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-query',
                template: "\n  <div class=\"card\">\n    <div class=\"card-header\">\n      <div class=\"float-left\">\n        <h5>{{title}}</h5>\n      </div>\n      <div class=\"btn-toolbar float-right\">\n\n        <div class=\"btn-group btn-group-sm ml-1\" *ngIf=\"queryTemplates.length>1\">\n          <button type=\"button\" class=\"btn btn-secondary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n            <i class=\"fa fa-retweet\"></i> {{currentQueryTemplate.name}}\n            <span class=\"caret\"></span>\n          </button>\n          <div class=\"dropdown-menu\" aria-labelledby=\"btnGroupDrop1\">\n            <a *ngFor=\"let item of queryTemplates\" href=\"javascript:\"\n              class=\"dropdown-item\" (click)=\"queryTemplateChanged(item)\">{{item.name}}</a>\n          </div>\n        </div>\n\n        <div class=\"btn-group btn-group-sm ml-1\" *ngIf=\"showModeButtons\">\n          <button type=\"button\" class=\"btn\" (click)=\"showPlainPanel()\"\n            [ngClass]=\"{'btn-primary': mode===plainMode, 'btn-secondary': mode!==plainMode}\">\n            <i class=\"fa fa-filter\"></i> {{config.labels.buttons.quick}}</button>\n          <button type=\"button\" class=\"btn\" (click)=\"showAdvancedPanel()\"\n            [ngClass]=\"{'btn-primary': mode===advancedMode, 'btn-secondary': mode!==advancedMode}\">\n            <i class=\"fa fa-fire\"></i> {{config.labels.buttons.advanced}}</button>\n        </div>\n\n        <div class=\"btn-group btn-group-sm ml-1\">\n          <button type=\"button\" class=\"btn btn-secondary\" (click)=\"resetQueryTemplate()\">\n            <i class=\"fa fa-repeat\"></i> {{config.labels.buttons.reset}}</button>\n          <button type=\"button\" class=\"btn btn-primary\" (click)=\"executeQuery()\">\n            <i class=\"fa fa-search\"></i> {{config.labels.buttons.search}}</button>\n        </div>\n\n        <ng-container *ngIf=\"toolbarTemplate\" [ngTemplateOutlet]=\"toolbarTemplate\"\n                    [ngOutletContext]=\"{toolbar: toolbar}\"></ng-container>\n\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n    <div class=\"card-body\">\n      <ngx-query-plain [hidden]=\"mode!==plainMode\" #planQuery\n        [queryTemplate]=\"currentQueryTemplate.template\">\n      </ngx-query-plain>\n      <ngx-query-advanced [hidden]=\"mode!==advancedMode\" #advancedQuery\n        [queryTemplate]=\"currentQueryTemplate.template\" [fields]=\"tempFields\">\n      </ngx-query-advanced>\n    </div>\n  </div>\n\n  <!-- Value Input Templates -->\n  <ng-template ngx-query-value-input-template dataType=\"any\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <input type=\"text\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" [(ngModel)]=\"rule.datas[dataIndex]\" />\n  </ng-template>\n  <ng-template ngx-query-value-input-template dataType=\"string\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <input type=\"text\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" [(ngModel)]=\"rule.datas[dataIndex]\" />\n  </ng-template>\n  <ng-template ngx-query-value-input-template dataType=\"boolean\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <label class=\"custom-control custom-checkbox\">\n      <input type=\"checkbox\" class=\"custom-control-input\"\n        [placeholder]=\"placeholder ? placeholder : rule.field.label\" [(ngModel)]=\"rule.datas[dataIndex]\" />\n      <span class=\"custom-control-indicator\"></span>\n    </label>\n  </ng-template>\n  <ng-template ngx-query-value-input-template dataType=\"number\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <input type=\"number\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" [(ngModel)]=\"rule.datas[dataIndex]\" />\n  </ng-template>\n  <ng-template ngx-query-value-input-template dataType=\"date\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <input *ngIf=\"!datePickerReadonly\" type=\"text\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" bsDatepicker\n      #dp=\"bsDatepicker\" [(bsValue)]=\"rule.datas[dataIndex]\" />\n    <input *ngIf=\"datePickerReadonly\" readonly type=\"text\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" bsDatepicker\n      #dp=\"bsDatepicker\" [(bsValue)]=\"rule.datas[dataIndex]\" />\n  </ng-template>\n  <ng-template ngx-query-value-input-template dataType=\"datetime\" let-rules=\"rules\"\n      let-rule=\"rule\" let-dataIndex=\"dataIndex\" let-placeholder=\"placeholder\">\n    <input type=\"date\" class=\"form-control form-control-sm\"\n      [placeholder]=\"placeholder ? placeholder : rule.field.label\" [(ngModel)]=\"rule.datas[dataIndex]\" />\n  </ng-template>\n  <!-- Value Input Templates -->\n  ",
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'ngx-query'
                }
            },] },
];
/** @nocollapse */
QueryComponent.ctorParameters = function () { return [
    { type: QueryConfigurationService, },
]; };
QueryComponent.propDecorators = {
    'query': [{ type: Output },],
    'reset': [{ type: Output },],
    'title': [{ type: Input },],
    'datePickerReadonly': [{ type: Input },],
    'mode': [{ type: Input },],
    'showModeButtons': [{ type: Input },],
    'fieldTemplates': [{ type: ContentChildren, args: [FieldDirective,] },],
    'fields': [{ type: Input },],
    'queryTemplates': [{ type: Input },],
    'toolbarTemplate': [{ type: ContentChild, args: [ToolbarTemplateDirective, { read: TemplateRef },] },],
    'toolbar': [{ type: Input },],
    '_plainQuery': [{ type: ViewChild, args: [PlainComponent,] },],
    '_advancedQuery': [{ type: ViewChild, args: [AdvancedComponent,] },],
    'defaultValueInputTemplates': [{ type: ViewChildren, args: [ValueInputTemplateDirective,] },],
};
//# sourceMappingURL=query.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/query.component.js
// module id = null
// module chunks = 